import React from 'react';


/**
 * Social Icons Widget
 */
const SocialWidget = (props) => {
    const { 
        twitter = null, 
        instagram = null,
        website = null, 
        ...restProps 
    } = props;
    if ( !twitter && !instagram && !website ) return;


    return (
        <div className="acaWidget acaWidget--socials">
            <div className="acaH4 acaWidget__title">Socials</div>
            <div className="acaWidget__inner socialIcons">
                { twitter ? (
                    <SocialIcon
                        icon="x"
                        title="Find us on X"
                        link={"https://x.com/" + twitter + "/"}
                    />
                ) : '' }
                { instagram ? (
                    <SocialIcon
                        icon="instagram"
                        title="Find us on Instagram"
                        link={"https://www.instagram.com/" + instagram + "/"}
                    />
                ) : '' }
                { website ? (
                    <SocialIcon
                        icon="website"
                        title="Visit our website"
                        link={website}
                    />
                ) : '' }
            </div>
        </div>
    );
}


const SocialIcon = (props) => {
    const {
        icon = null,
        title = null,
        link = null, 
        ...restProps
    } = props;
    if ( !icon || !link ) return;

    return (
        <a href={link} className={"socialIcon socialIcon--" + icon} target="_blank">
            <span className="socialIcon__inner"></span>
            { title ? (
                <span className="screen-reader-text socialIcon__sr">{title}</span>
            ) : '' }
        </a>
    );
}





/**
 * Export
 */
export { SocialWidget };

